import React, { useState } from 'react';
import { api } from '../utils/api';

export default function PropertyFeedback({ propertyId }) {
  const [reply, setReply] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const generate = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await api.getPropertyFeedback(propertyId, 'claude');
      setReply(data.reply);
    } catch (err) {
      setError(err.message || 'Failed to generate feedback');
    } finally {
      setLoading(false);
    }
  };

  if (!reply && !loading && !error) {
    return (
      <button style={styles.triggerBtn} onClick={generate}>
        🤖 Get AI Read on This Property
      </button>
    );
  }

  return (
    <div style={styles.card}>
      <div style={styles.cardHeader}>
        <span style={styles.cardTitle}>🤖 AI Investment Read</span>
        <button style={styles.refreshBtn} onClick={generate} disabled={loading}>
          {loading ? '...' : '↻ Refresh'}
        </button>
      </div>
      {loading && !reply && <p style={styles.loadingText}>Analyzing...</p>}
      {error && <p style={styles.errorText}>{error}</p>}
      {reply && <p style={styles.replyText}>{reply}</p>}
    </div>
  );
}

const styles = {
  triggerBtn: {
    width: '100%',
    background: 'rgba(167,139,250,0.1)',
    border: '1px solid rgba(167,139,250,0.4)',
    color: '#a78bfa',
    borderRadius: '8px',
    padding: '10px',
    fontSize: '0.8rem',
    fontWeight: '700',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
    marginTop: '0.75rem',
  },
  card: {
    background: '#0a0f1e',
    border: '1px solid rgba(167,139,250,0.3)',
    borderRadius: '10px',
    padding: '0.9rem',
    marginTop: '0.75rem',
  },
  cardHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' },
  cardTitle: { color: '#a78bfa', fontSize: '0.78rem', fontWeight: '700', fontFamily: "'Syne', sans-serif" },
  refreshBtn: {
    background: 'transparent', border: 'none', color: '#6b7280', fontSize: '0.7rem',
    cursor: 'pointer', fontFamily: "'Syne', sans-serif", fontWeight: '600',
  },
  loadingText: { color: '#6b7280', fontSize: '0.8rem', margin: 0 },
  errorText: { color: '#ef4444', fontSize: '0.8rem', margin: 0 },
  replyText: { color: '#d1d5db', fontSize: '0.82rem', lineHeight: '1.6', margin: 0, whiteSpace: 'pre-wrap' },
};
